import { mapValues } from 'lodash';

import {
    ADD_RETARGETING_LIST_ITEM,
    CANCEL_DELETE_RETARGETING_LIST_ITEM,
    CHANGE_RETARGETING_LIST_ITEM_SELECTION,
    CHANGE_RETARGETING_LIST_SELECTION,
    CLOSE_RETARGETING_EDITOR,
    DELETE_RETARGETING_LIST_ITEM,
    OPEN_RETARGETING_EDITOR,
    REQUEST_DELETE_RETARGETING_LIST_ITEM,
    RESET_RETARGETING_EDITORS,
    RetargetingEditorAction,
    UPDATE_RETARGETING_LIST_ITEM
} from '../actions/retargetingEditor';
import { RetargetingEditorState } from '../typings/retargeting';
import { RetargetingEditorsState, State } from '../typings/state';

export const defaultRetargetingEditorState: RetargetingEditorState = {
    isVisible: false,
    conditions: []
};

export function retargetingEditor(
    state: RetargetingEditorsState = {},
    action: RetargetingEditorAction,
    fullState: State
): RetargetingEditorsState {
    switch (action.type) {
        case OPEN_RETARGETING_EDITOR: {
            const editorState =
                state[action.id] || defaultRetargetingEditorState;

            return {
                ...state,
                [action.id]: {
                    ...editorState,
                    conditions: action.conditionsData.map(condition => {
                        return {
                            ...condition,
                            isSelected: action.selectedConditionsIds.includes(
                                condition.id
                            ),
                            isDeleting: false,
                            isFiltered: true
                        };
                    }),
                    isVisible: true
                }
            };
        }

        case CLOSE_RETARGETING_EDITOR:
            return {
                ...state,
                [action.id]: {
                    ...defaultRetargetingEditorState,
                    isVisible: false
                }
            };

        case CHANGE_RETARGETING_LIST_ITEM_SELECTION: {
            const editorState =
                state[action.id] || defaultRetargetingEditorState;
            const newConditions = [...editorState.conditions];
            newConditions[action.index].isSelected = !newConditions[
                action.index
            ].isSelected;

            return {
                ...state,
                [action.id]: {
                    ...editorState,
                    conditions: newConditions
                }
            };
        }

        case CHANGE_RETARGETING_LIST_SELECTION: {
            const editorState =
                state[action.id] || defaultRetargetingEditorState;
            return {
                ...state,
                [action.id]: {
                    ...editorState,
                    conditions: editorState.conditions.map(condition => {
                        return {
                            ...condition,
                            isSelected: action.isSelected
                        };
                    })
                }
            };
        }

        case REQUEST_DELETE_RETARGETING_LIST_ITEM: {
            const editorState =
                state[action.id] || defaultRetargetingEditorState;
            const newConditions = [...editorState.conditions];
            newConditions[action.index].isDeleting = true;
            const listGroupIds = Object.keys(state);
            const updatedEditors = listGroupIds.reduce((acc, groupId) => {
                acc[groupId] = {
                    ...state[groupId],
                    conditions: newConditions
                };

                return acc;
            }, {});

            return {
                ...state,
                ...updatedEditors
            };
        }

        case DELETE_RETARGETING_LIST_ITEM: {
            const editorState =
                state[action.id] || defaultRetargetingEditorState;
            const newConditions = [...editorState.conditions];
            newConditions.splice(action.index, 1);
            const listGroupIds = Object.keys(state);
            const updatedEditors = listGroupIds.reduce((acc, groupId) => {
                acc[groupId] = {
                    ...state[groupId],
                    conditions: newConditions
                };

                return acc;
            }, {});

            return {
                ...state,
                ...updatedEditors
            };
        }

        case CANCEL_DELETE_RETARGETING_LIST_ITEM: {
            const editorState =
                state[action.id] || defaultRetargetingEditorState;
            const newConditions = [...editorState.conditions];
            newConditions[action.index].isDeleting = false;
            const listGroupIds = Object.keys(state);
            const updatedEditors = listGroupIds.reduce((acc, groupId) => {
                acc[groupId] = {
                    ...state[groupId],
                    conditions: newConditions
                };

                return acc;
            }, {});

            return {
                ...state,
                ...updatedEditors
            };
        }

        case UPDATE_RETARGETING_LIST_ITEM: {
            return mapValues(state, editorItem => {
                return {
                    ...editorItem,
                    conditions: editorItem.conditions.map(condition => {
                        return condition.id === action.conditionData.id
                            ? { ...condition, ...action.conditionData }
                            : condition;
                    }),
                    conditionIdToScrollTo: action.conditionData.id
                };
            });
        }

        case ADD_RETARGETING_LIST_ITEM: {
            return mapValues(state, (editorGroup, groupId) => {
                return {
                    ...editorGroup,
                    conditions: [
                        ...editorGroup.conditions,
                        {
                            ...action.conditionData,
                            isSelected: groupId === action.groupId,
                            isDeleting: false
                        }
                    ],
                    conditionIdToScrollTo: action.conditionData.id
                };
            });
        }

        case RESET_RETARGETING_EDITORS: {
            return {};
        }

        default:
            return state;
    }
}
